export const PAYMENT_REQUEST_WORKFLOW_KEYS = {
	ALL: 'ALL',
	SUBMITTED: 'SUBMITTED',
	IN_PROGRESS: 'IN_PROGRESS',
	PARTIALLY_DONE: 'PARTIALLY_DONE',
	DONE: 'DONE',
	REJECTED: 'REJECTED',
};

export const PAYMENT_REQUEST_WORKFLOW_LABELS = {
	ALL: 'همه',
	SUBMITTED: 'ثبت شده',
	IN_PROGRESS: 'در حال بررسی',
	PARTIALLY_DONE: 'بخشی پرداخت شده',
	DONE: 'تسویه شده',
	REJECTED: 'رد شده',
};

export const PAYMENT_REQUEST_WORKFLOW_STATES = {
	ALL: [],
	SUBMITTED: ['new'],
	IN_PROGRESS: [
		'in_progress',
		'reviewed',
		'review',
		'vs_confirmed',
		'confirm',
		'pay',
		'pend',
	],
	PARTIALLY_DONE: ['partially_done'],
	DONE: ['done'],
	REJECTED: ['rejected', 'reject'],
};

export const onGetPaymentStatusTag = (workflowState) => {
	if (PAYMENT_REQUEST_WORKFLOW_STATES.SUBMITTED.includes(workflowState))
		return {
			title: PAYMENT_REQUEST_WORKFLOW_LABELS.SUBMITTED,
			variant: 'warning',
		};

	if (PAYMENT_REQUEST_WORKFLOW_STATES.IN_PROGRESS.includes(workflowState))
		return {
			title: PAYMENT_REQUEST_WORKFLOW_LABELS.IN_PROGRESS,
			variant: 'warning',
		};

	if (PAYMENT_REQUEST_WORKFLOW_STATES.DONE.includes(workflowState))
		return {
			title: PAYMENT_REQUEST_WORKFLOW_LABELS.DONE,
			variant: 'success',
		};

	if (PAYMENT_REQUEST_WORKFLOW_STATES.REJECTED.includes(workflowState))
		return {
			title: PAYMENT_REQUEST_WORKFLOW_LABELS.REJECTED,
			variant: 'error',
		};

	if (PAYMENT_REQUEST_WORKFLOW_STATES.PARTIALLY_DONE.includes(workflowState))
		return {
			title: PAYMENT_REQUEST_WORKFLOW_LABELS.PARTIALLY_DONE,
			variant: 'info',
		};

	return { variant: '', title: '' };
};

export const TRANSACTIONS_WORKFLOW_KEYS = {
	IN_PROGRESS: 'IN_PROGRESS',
	PENDING: 'PENDING',
	DONE: 'DONE',
	REJECTED: 'REJECTED',
};

export const TRANSACTIONS_WORKFLOW_LABELS = {
	IN_PROGRESS: 'در حال پرداخت',
	PENDING: 'در انتظار پرداخت',
	DONE: 'پرداخت شده',
	REJECTED: 'رد شده',
};

export const TRANSACTIONS_WORKFLOW_STATES = {
	IN_PROGRESS: ['in_progress', 'new', 'pay'],
	PENDING: ['pending', 'pend'],
	DONE: ['done'],
	REJECTED: ['reject', 'rejected'],
};

export const onGetTransactionStatusTag = (workflowState) => {
	if (TRANSACTIONS_WORKFLOW_STATES.IN_PROGRESS.includes(workflowState))
		return {
			title: TRANSACTIONS_WORKFLOW_LABELS.IN_PROGRESS,
			variant: 'info',
		};

	if (TRANSACTIONS_WORKFLOW_STATES.PENDING.includes(workflowState))
		return {
			title: TRANSACTIONS_WORKFLOW_LABELS.PENDING,
			variant: 'warning',
		};
	if (TRANSACTIONS_WORKFLOW_STATES.DONE.includes(workflowState))
		return {
			title: TRANSACTIONS_WORKFLOW_LABELS.DONE,
			variant: 'success',
		};

	if (TRANSACTIONS_WORKFLOW_STATES.REJECTED.includes(workflowState))
		return {
			title: TRANSACTIONS_WORKFLOW_LABELS.REJECTED,
			variant: 'error',
		};

	return { variant: '', title: '' };
};
